<template>
  <div class="error-statistics">
    <div class="passing-module-title">
      <span>异常信息统计</span>
      <i class="el-icon-s-tools" @click="openSortTransfer"></i>
    </div>
    <div class="table">
      <el-table :data="abnormalList" border style="width: 100%" height="195" tooltip-effect="dark"
        :row-class-name="tableRowClassName" :header-cell-style="{ background: '#ff9409', color: '#ffffff' }">
        <el-table-column type="index" align="center" width="40"></el-table-column>
        <el-table-column prop="threeClass" label="异常类型" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="totalCount" label="总数" align="center" width="60">
          <template slot-scope="scope">
            <el-link type="primary">{{ scope.row.totalCount }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="dealCount" label="已处理" align="center" width="60">
          <template slot-scope="scope">
            <el-button type="text" size="small"></el-button>
            <el-link type="success">{{ scope.row.dealCount }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="60">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="getInfo(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <template v-slot:empty>
          <div class="no-data-wrapper">
            <el-empty description="暂无数据" :image-size="80"></el-empty>
          </div>
        </template>
      </el-table>
    </div>

    <dialog-reset slotShow height="400px" width="650px" title="异常类型设置" :zoomShow="false" :visible.sync="transferShow"  v-loading="loading">
      <sort-transfer ref="SortTransfer" @getTransfer="getTransfer" :titles="['异常类型', '显示']" :list="allData"
        :props="{ key: 'id', label: 'threeClass' }"></sort-transfer>
      <span slot="dialog_footer">
        <el-button @click="transferShow = false" v-loading="loading">取 消</el-button>
        <el-button type="primary" @click="closeSortTransfer" v-loading="loading">确 定</el-button>
      </span>
    </dialog-reset>

    <dialog-reset slotShow height="auto" width="950px" title="异常类别详情" :visible.sync="classInfoShow">
      <h3 style="margin-top: 0;">{{ threeClass }}</h3>
      <el-table :data="classInfoList" border style="width: 100%" height="500">
        <el-table-column prop="passTime" label="过车时间" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="trainType" label="车型" align="center"></el-table-column>
        <el-table-column prop="trainNo" label="车号" align="center"></el-table-column>
        <el-table-column prop="containerNo1" label="集装箱号(1)" align="center"></el-table-column>
        <el-table-column prop="containerNo2" label="集装箱号(2)" align="center"></el-table-column>
        <el-table-column prop="dealStatus" label="处理情况" align="center">
          <template slot-scope="scope">
            <dict-tag :options="dict.type.handling_situation" :value="scope.row.dealStatus" />
          </template>
        </el-table-column>
        <el-table-column prop="flag" label="标记类型" align="center">
          <template slot-scope="scope">
            <dict-tag :options="dict.type.tag_type" :value="scope.row.flag" />
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
        @pagination="getInfoList" />
    </dialog-reset>
  </div>
</template>

<script>
import SortTransfer from '@/components/SortTransfer/index.vue'
import { checkUpdate, getStatistics, getCheckData, getStatisticsDetail } from '@//api/handover-inspection/passing-manage.js'

export default {
  name: "error-statistics",
  components: {
    SortTransfer
  },
  dicts: ["handling_situation", "tag_type"],
  data() {
    return {
      abnormalList: [],//异常信息列表
      transferShow: false,
      allData: [],//异常类型列表【全部】
      checkData: [],//异常类型列表【已选择】
      threeClass: '',//类别明细标题
      classInfoList: [],//类别明细列表
      classInfoShow: false,//类别明细弹窗
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        trainListId: null,	//车次id
        threeclassCode: null,	//异常编码
      },
      loading: false
    };
  },
  mounted() {
    // this.statistics()
    this.$bus.on('searchErrStatistics', this.statistics)
  },
  methods: {
    // 根据列车id获取问题统计
    statistics(form) {
      if (typeof form.trainListId == 'undefined') {
        this.queryParams = {
          ...this.queryParams, ...{
            poundno: form.poundno,//	股道
            trainNo: form.trainNo,//	车号
            comeTimeStart: form.searchDate[0],//	来车时间（开始）
            comeTimeEnd: form.searchDate[1],//来车时间（结束）
            direction: form.direction,//	来车方向（0：未知；1：到达；2：发出）
          }
        }
      } else {
        this.queryParams.trainListId = form.trainListId
      }
      this.getList()
    },
    //根据列车id获取问题统计
    getList() {
      this.loading = true
      getStatistics(this.queryParams).then(res => {
        this.abnormalList = res.data
        this.loading = false
      })
    },
    //打开设置展示排序弹窗
    openSortTransfer() {
      this.transferShow = true
      getCheckData().then(res => {
        this.allData = res.data.checkData.concat(res.data.allData) //异常类型列表【全部】
        this.checkData = res.data.checkData//异常类型列表【已选择】
        this.$nextTick(() => {
          this.$refs.SortTransfer.getList(res.data.checkData)
        })
      })
    },
    //获取选择后的数据
    getTransfer(list) {
      this.checkData = list.map(item => this.allData.filter(res => { return res.id == item })).flat(1);
    },
    //关闭设置展示排序弹窗
    closeSortTransfer() {
      this.loading = true
      checkUpdate({
        allData: this.allData,
        checkData: this.checkData
      }).then(res => {
        if (res.code == 200) {
          this.transferShow = false
          this.$message({
            message: '异常类型设置成功',
            type: 'success'
          });
          this.loading = false
          this.getList()
        }
      })
    },
    // 查看详情
    getInfo(row) {
      this.classInfoShow = true
      this.queryParams.threeclassCode = row.threeclassCode
      this.threeClass = row.threeClass
      this.getInfoList()
    },
    //获取详情列表
    getInfoList() {
      getStatisticsDetail(this.queryParams).then(res => {
        this.classInfoList = res.rows
        this.total = res.total
      })
    },
    // 表格行背景色
    tableRowClassName({ row, rowIndex }) {
      return 'table-bg-color';
    },
  },
  beforeDestroy() {
    this.$bus.off('searchErrStatistics', this.statistics)
  }
};
</script>

<style>
.table-bg-color {
  background-color: #fbf1cc !important;
}
</style>
<style scoped lang="scss">
.passing-module-title {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-icon-s-tools {
    font-size: 18px;
    color: #515a6e;
  }
}

.table {
  ::v-deep .el-table {
    background: #fbf1cc !important;
  }
}


::v-deep .el-empty__description {
  margin-top: 0;
}
</style>
